import React, { forwardRef, ReactNode } from 'react';
import { Flex, Box } from '../Rebass';
import { SxStyleProp } from '../Rebass/types';
import Heading from '../Heading';
import styled from '@emotion/styled';
import Logo from '../Logo';
import theme from '../../theme';
import Image from '../Image';
import Pattern, { PatternProps } from '../Pattern';

interface BannerProps {
  headline?: string;
  image?: string;
  cite?: string;
  showLogo?: boolean;
  showPattern?: boolean;
  patternProps?: PatternProps;
  children?: ReactNode;
  sx?: SxStyleProp;
  citeSx?: SxStyleProp;
  renderCta?: () => React.ReactNode;
}

const BannerContainer = styled(Flex)`
  text-align: center;
  min-height: 700px;
  align-items: center;
  justify-content: center;
`;

const Banner = forwardRef<HTMLDivElement, BannerProps>(
  (
    {
      headline,
      cite,
      image,
      showLogo = true,
      showPattern = false,
      patternProps,
      children,
      citeSx,
      sx,
      renderCta,
    }: BannerProps,
    ref,
  ) => {
    return (
      <BannerContainer
        ref={ref}
        pt={[6, 12]}
        pb={[10, 12]}
        height={['100%']}
        width={[1]}
        sx={sx}
      >
        <Box px={['30px', '15px']} sx={{ maxWidth: '840px' }}>
          <Box sx={{ position: 'relative' }}>
            {showPattern && <Pattern {...patternProps} />}
            {showLogo && <Logo color={theme.colors.baseWhite} />}
            {headline && (
              <Heading size="h1" py={[4, 6]} color={theme.colors.textWhite}>
                {headline}
              </Heading>
            )}
            {children && <Box mb={[4, 6]}>{children}</Box>}
            {cite && (
              <Heading
                size="h7"
                pb={[4, 6]}
                fontFamily={'variable'}
                sx={{ color: theme.colors.textWhite, ...citeSx }}
              >
                {cite}
              </Heading>
            )}
            {image && (
              <Box mb={[2, 4]} m={'auto'} width={['120px']}>
                <Image src={image} alt={headline || null} />
              </Box>
            )}
            {renderCta && (
              <Flex
                flexDirection={['column', 'column', 'column', 'row']}
                alignItems={'center'}
                justifyContent="center"
              >
                {renderCta()}
              </Flex>
            )}
          </Box>
        </Box>
      </BannerContainer>
    );
  },
);

export default Banner;
